import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores/Store';


interface IProps {
    component: React.ComponentType<any>;
}
const PrivateRoute: React.FC<IProps> = ({ component: Component }) => {
    const { userStore } = useStore();
    const { isLoggedIn } = userStore;

    return isLoggedIn ? <Component /> : <Navigate to={'/'} replace />
}

export default observer(PrivateRoute);
